import { render } from "./RecomendedInfo.vue?vue&type=template&id=7304a7a8&scoped=true"
import script from "./RecomendedInfo.vue?vue&type=script&lang=js"
export * from "./RecomendedInfo.vue?vue&type=script&lang=js"

import "./RecomendedInfo.vue?vue&type=style&index=0&id=7304a7a8&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7304a7a8"],['__file',"webpack-assets/vue/templates/product/catalog/parts/RecomendedInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7304a7a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7304a7a8', __exports__)) {
    api.reload('7304a7a8', __exports__)
  }
  
  module.hot.accept("./RecomendedInfo.vue?vue&type=template&id=7304a7a8&scoped=true", () => {
    api.rerender('7304a7a8', render)
  })

}


export default __exports__